module.exports = __webpack_public_path__ + "img/expertsystem.caf33402.png";